<div class="tw-w-full tw-h-14 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-px-6 tw-bg-black">
  <div class="tw-absolute tw-left-6 tw-top-2 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
    <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
  </div>
  <span class="tw-font-body tw-font-bold tw-text-300 tw-text-white" i18n="@@checkup">Check-up</span>
</div>
<div class="tw-w-full tw-pt-20 tw-pl-4 tw-pr-4 tw-font-body xxs:tw-px-7">
  <div class="tw-flex tw-flex-col tw-gap-1 tw-mb-10">
    @if (isSpentLessThanThreshold) {
      <p class="tw-text-300 tw-text-center" i18n="@@restartTreatmentAndUnlockCheckup">Restart Treatment & Unlock Check-up</p>
    }
    <h2 class="tw-text-600 tw-font-bold tw-text-center" i18n="@@chooseYourConcern">Choose your concern</h2>
    @if (!isSpentLessThanThreshold) {
      <p class="tw-text-300 tw-text-center" i18n="@@doctorWillAnalyseYourPhotoAndDoCheckup">Doctor will analyse your photo and <br /> do a checkup</p>
    }
  </div>
  <regimen-concern-selection class="tw-bg-white tw-rounded-tr-5 tw-rounded-tl-5" [isRebranding]="true" [concernClass]="selectedConcernClass" [gender]='user?.get("Gender")' (selectConcern)="updateConcern($event)"></regimen-concern-selection>
</div>